import MPADataSourcesMeasures from './MPADataSourcesMeasures';

export default MPADataSourcesMeasures;
